<div id="react-native-root">
  <div id="react-native-body">
    <app-skeleton-loader
      id="skeleton-loader"
      *ngIf="online && !bundleLoaded"
    ></app-skeleton-loader>
  </div>
</div>
